import { consumptionMapActions } from "../actions";
const {
  FETCH_INITIAL_STATE,
  FETCH_CONSUMPTION_MAP,
  FETCHING_CONSUMPTION_MAP,
  FETCH_CONSUMPTION_MAP_ERROR,
  FETCH_CONSUMPTION_MAP_ITEM,
  FETCHING_CONSUMPTION_MAP_ITEM,
  FETCH_CONSUMPTION_MAP_ITEM_ERROR,
  CLEAN_YEAR,
  CHANGE_YEAR,
  FETCHING_YEAR_LIST,
  FETCH_YEAR_LIST,
  FETCH_YEAR_LIST_ERROR,
  FETCHING_CONSUMPTION_MAP_AREAS,
  FETCH_CONSUMPTION_MAP_AREAS,
  FETCH_CONSUMPTION_MAP_AREAS_ERROR,
  CHANGE_AREA
} = consumptionMapActions;

const initialState = {
  fetching: {
    consumptionMap: false,
    consumptionMapItem: false,
    yearList: false
  },
  year: '',
  areaId: '',
  areaName: '',
  yearList: [],
  items: [],
  last_update: undefined,
  consumptionMapItem: {},
  area: '',
  areaList: [],
  fetch_errors: {
    consumptionMap: false,
    consumptionMapItem: false,
    yearList: false
  }
};

const consumptionMap = (state = initialState, action = "") => {
  switch (action.type) {
    case CLEAN_YEAR:
      return {
        ...state,
        year: '',
        items: []
      }
    case FETCH_INITIAL_STATE:
      return {
        ...state,
        items: [],
        year: '',
        yearList: []
      }
    case FETCH_CONSUMPTION_MAP:
      return {
        ...state,
        last_update: action.last_update,
        items: action.items,
        fetching: { ...state.fetching, consumptionMap: false },
        fetch_errors: {
          ...state.fetch_errors,
          consumptionMap: false
        }
      };
    case FETCHING_CONSUMPTION_MAP:
      return {
        ...state,
        fetching: { ...state.fetching, consumptionMap: action.value }
      };

    // // Erros
    case FETCH_CONSUMPTION_MAP_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          consumptionMapItem: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          consumptionMapItem: true
        }
      };
    // Single Consumption Map
    case FETCH_CONSUMPTION_MAP_ITEM:
      return {
        ...state,
        last_update: action.last_update,
        consumptionMapItem: action.item,
        fetching: { ...state.fetching, consumptionMapItem: false },
        fetch_errors: {
          ...state.fetch_errors,
          consumptionMapItem: false
        }
      };
    case FETCHING_CONSUMPTION_MAP_ITEM:
      return {
        ...state,
        fetching: { ...state.fetching, consumptionMapItem: action.item }
      };

    // // Erros
    case FETCH_CONSUMPTION_MAP_ITEM_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          consumptionMapItem: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          consumptionMapItem: true
        }
      };

    case CHANGE_YEAR:
      return { ...state, year: action.value };

    case CHANGE_AREA:
      return {
        ...state,
        areaId: (action.value || {}).value,
        areaName: (action.value || {}).label
      };

    case FETCHING_YEAR_LIST:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          yearsList: true
        }
      }

    case FETCH_YEAR_LIST:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          yearsList: false
        },
        yearList: action.items,
        fetch_errors: {
          ...state.fetch_errors,
          yearList: false
        }
      }

    case FETCH_YEAR_LIST_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          yearsList: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          yearList: true
        }
      }

    case FETCHING_CONSUMPTION_MAP_AREAS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          areasList: true
        }
      }

    case FETCH_CONSUMPTION_MAP_AREAS:
      const initialArea = action.items.find(item => item);

      return {
        ...state,
        fetching: {
          ...state.fetching,
          areasList: false
        },
        area: (initialArea || {}).value,
        areaList: action.items,
        fetch_errors: {
          ...state.fetch_errors,
          areaList: false
        }
      }

    case FETCH_CONSUMPTION_MAP_AREAS_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          areasList: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          areaList: true
        }
      }

    default:
      return state;
  }
};

export default consumptionMap;



// WEBPACK FOOTER //
// ./src/reducers/consumptionMap.js